'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { motion } from 'framer-motion';
import type React from 'react';
import { forwardRef } from 'react';
import { cn } from '../../../shared/cn';
import { TouchTarget } from '../../actions/Button';
import { Link } from '../../actions/Link';
type NavbarItemProps = {
  current?: boolean;
  className?: string;
  children: React.ReactNode;
};
type NavbarItemButtonProps = NavbarItemProps & Omit<Headless.ButtonProps, 'as' | 'className'>;
type NavbarItemLinkProps = NavbarItemProps & Omit<React.ComponentPropsWithoutRef<typeof Link>, 'className'> & {
  href: string;
};
export const NavbarItem = forwardRef(function NavbarItem(t0, ref) {
  const $ = _c(19);
  let children;
  let className;
  let current;
  let props;
  if ($[0] !== t0) {
    ({
      current,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = current;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    current = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("relative flex min-w-0 cursor-default items-center gap-3 rounded-lg p-2 text-left text-base/6 font-medium text-contentPrimary sm:text-sm/5", "*:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5", "*:not-nth-2:last:data-[slot=icon]:ml-auto *:not-nth-2:last:data-[slot=icon]:size-5 sm:*:not-nth-2:last:data-[slot=icon]:size-4", "*:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 *:data-[slot=avatar]:[--avatar-radius:var(--radius-md)] sm:*:data-[slot=avatar]:size-6", "data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950", "data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950", "dark:text-white dark:*:data-[slot=icon]:fill-zinc-400", "dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white", "dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white");
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const classes = t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn(className, "relative");
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== current) {
    t3 = current && <motion.span layoutId="current-indicator" className="absolute inset-x-1 -bottom-2.5 h-0.5 rounded-full bg-zinc-950 dark:bg-white" />;
    $[8] = current;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== current || $[12] !== props || $[13] !== ref) {
    t4 = "href" in props && typeof props.href === "string" ? <Link {...props as NavbarItemLinkProps} className={classes} data-current={current ? "true" : undefined} ref={ref as React.ForwardedRef<HTMLAnchorElement>}><TouchTarget>{children}</TouchTarget></Link> : <Headless.Button {...props as NavbarItemButtonProps} className={classes} data-current={current ? "true" : undefined} ref={ref}><TouchTarget>{children}</TouchTarget></Headless.Button>;
    $[10] = children;
    $[11] = current;
    $[12] = props;
    $[13] = ref;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <span className={t2}>{t3}{t4}</span>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
});